import { z } from 'zod';
export const nullValidator = ({ error, }) => {
    if (!error) {
        return z.null();
    }
    return z.null({
        error,
    });
};
